import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { getProjectRecordTotalHours } from '../services/getProjectRecordTotalHours.service';

/**
 * Loads the selected project's record hour totals (`recordHourData`: day,
 * week, month, year). `loadedAt` (epoch ms) says when they came in: a record
 * clocked out after it is not in them yet, and the redesigned dashboard adds
 * such records' time itself.
 */
export const loadProjectRecordTotalHours = createAsyncThunk(
  'records/loadProjectRecordTotalHours',
  async (_, { getState }) => {
    const state = getState();

    const selectedProjectId = selectSelectedProjectId(state);

    const recordTotals = await getProjectRecordTotalHours(selectedProjectId);

    return { ...recordTotals, loadedAt: Date.now() };
  }
);
